window.JOI = {};
window.JOI.ids = [];

const generateID = (type) => {
  let id = type + window.JOI.ids.length;
  window.JOI.ids.push(id);
  return id;
}
